import { NgModule } from '@angular/core';
import { TooltipAlertComponent } from './alert/tooltip-alert.component';
import { IntrackFeatureModule } from '../../intrack-feature.module';
import { MatTooltipModule } from '@angular/material/tooltip';
import { SvgIconModule } from '../svg-icon/svg-icon.module';

@NgModule({
  declarations: [TooltipAlertComponent],
  imports: [IntrackFeatureModule, MatTooltipModule, SvgIconModule],
  exports: [TooltipAlertComponent],
})
export class TooltipModule {}
